<template>
  <b-row class="competency-change-status-navigation">
    <b-col cols="12" lg="4" class="competency-change-status-navigation__box">
      <span class="box-circle">
        <mdicon :name="generateCurrentStep.icon" size="24" />
      </span>
      <span class="box-caption">
        {{ generateCurrentStep.caption }}
      </span>
    </b-col>
    <b-col cols="auto" lg="4" class="competency-change-status-navigation__box">
      <span class="color-complementary-200">
        <mdicon name="arrow-left" size="24" />
      </span>
    </b-col>
    <b-col cols="12" lg="4" class="competency-change-status-navigation__box">
      <span class="box-circle">
        <mdicon name="send-outline" size="24" class="rotate-horizontal-180" />
      </span>
      <div class="box-right">
        <div class="box-buttons">
          <Button
            v-for="({ id, caption }, index) in getButtonSteps"
            :key="`button-${index}`"
            variant="primary"
            :text="caption"
            size="sm"
            class="margin-4"
            :loading="loading"
            @click="handleChangeStatus(id)"
          />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { Button } from "@/components/re-design/forms";
import { includes } from "ramda";
import { checkScreenDevice } from "@/shared/utils";
import { computed, ref, toRefs } from "vue";
export default {
  components: { Button },
  props: {
    currentCaseStatusId: {
      type: [Number, String],
      default: null,
    },
    currentUserExecutiveRoleId: {
      type: [Number, String],
      default: null,
    },
    allowSteps: {
      type: Array,
      default: () => [],
    },
    handleSubmit: {
      type: Function,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { currentCaseStatusId, currentUserExecutiveRoleId, allowSteps } =
      toRefs(props);
    const parvandehStatuses = [
      {
        id: 1,
        caption: "درحال بررسی ارزیاب",
        icon: "account-search-outline",
      },
      {
        id: 2,
        caption: "درحال بررسی ناظر کیفی",
        icon: "account-eye-outline",
      },
      {
        id: 3,
        caption: "درحال بررسی مدیر کانون",
        icon: "account-search-outline",
      },
      {
        id: 4,
        caption: "جمع بندی",
        icon: "account-eye-outline",
      },
      {
        id: 5,
        caption: "پایان فرایند ارزیابی",
        icon: "account-eye-outline",
      },
      {
        id: 6,
        caption: "تایید ویراستار",
        icon: "account-eye-outline",
      },
      {
        id: 7,
        caption: "درحال بازبینی ارزیاب",
        icon: "account-eye-outline",
      },
      {
        id: 8,
        caption: "درحال بازبینی ناظر کیفی",
        icon: "account-eye-outline",
      },
    ];
    const generateCurrentStep = computed(() => {
      return parvandehStatuses.find(
        ({ id }) => id === currentCaseStatusId.value
      );
    });
    const getButtonSteps = computed(() => {
      return allowSteps.value.filter(
        ({ allowStatuses, allowUserExecutiveRoles }) =>
          includes(currentCaseStatusId.value, allowStatuses) &&
          includes(currentUserExecutiveRoleId.value, allowUserExecutiveRoles)
      );
    });

    const loading = ref(false);
    const handleChangeStatus = async (caseStatusId) => {
      try {
        loading.value = true;
        await props.handleSubmit(caseStatusId);
      } catch (error) {
        //
      } finally {
        loading.value = false;
      }
    };

    // return data to be used in template
    return {
      checkScreenDevice,
      generateCurrentStep,
      getButtonSteps,
      loading,
      handleChangeStatus,
    };
  },
};
</script>
